export default class AppConfig {
    static Item_Per_Page = 10;
    static IPP_Unlimited = 10000;
    static BASE_URL = 'https://job-api-ujob.nobisoft.com.vn/';
    static BASE_API_URL = 'https://shop-api-ujob.nobisoft.com.vn/api/v1.0';
    //STEP:test
    static BASE_API_URL_USE = 'https://job-api-ujob.nobisoft.com.vn/api/v1.0'; //use login/image
    static PROVIDER = 'Vicocons';
    static DEFAULT_AVATAR_FILE_NAME = 'default_avatar_small.png';
    static DEFAULT_AVATAR_FILE_NAME_ORIGINAL = 'default_avatar.png';
    static DEFAULT_COVER_FILE_NAME = 'default_cover_small.png';
    static DEFAULT_COUPON_FILE_NAME = 'default_coupon_cover.png';
    static DEFAULT_COVER_FILE_NAME_ORIGINAL = 'default_cover.png';
    static DEFAULT_USER_SETTINGS = JSON.parse(`{"locale":"vn","avatar":"${AppConfig.DEFAULT_AVATAR_FILE_NAME}","cover_photo":"${AppConfig.DEFAULT_COVER_FILE_NAME}"}`);
    static DEFAULT_GET_UPLOADED_RESOURCE_WAITING_TIME_TO_LOAD_IN_SEC = 2 * 1000;
    static DEFAULT_GET_UPLOADED_RESOURCE_WAITING_TIME_TO_CLEAN_UP_IN_SEC = 0.5 * 1000;
    static TARGET_ACTION_UPLOAD_AVATAR = 0;
    static TARGET_ACTION_UPLOAD_COVER = 1;
    static TARGET_ACTION_UPLOAD_IMAGE = 2;
    static DEFAULT_PROVINCE_ID = 1;
    static DEFAULT_LONG = 1058387563;
    static DEFAULT_LAT = 210456863;
    static DESC = 'desc';
    static ASC = 'asc';
    static SYS_CATEGORY = 'f8cac340-ebdf-43fa-b983-77ab3abd8aee';
    static ALLOWED_FILE_EXTENSIONS = '.png,.jpg,.jpeg'
    static DATE_CONFIG = new Date(2000, 0, 1, 0, 0, 0);

}

export class JobManagement {
    static JOB_VIEW_TARGET_LIST = 'list';
    static JOB_VIEW_TARGET_RECORD = 'record';
    static JOB_TYPE_ALL = 0;  // Tat ca
    static JOB_TYPE_ASSIGNMENT = 1;  // Giao viec
    static JOB_TYPE_APPLICATION = 2;  // Nhan viec
    static JOB_TYPE_ASSIGNMENT_WITH_TIME_FRAME = 3; // Giao viec trong 1 khoang thoi gian
    static JOB_TYPE_APPLICATION_WITH_TIME_FRAME = 4;  // Nhan viec trong khoang thoi gian
    static JOB_TYPE_ASSIGNMENT_URGENT = 5;  // Viec khan cap
}

export class ModuleManagement {
    static USER_MANAGEMENT = "user-management";
    static JOB_MANAGEMENT = "job-management";
    static MASTER_DATA_MANAGEMENT = "master_data-management";
    static STORE_MANAGEMENT = "store-management";
    static CATEGORY_MANAGEMENT = "category-management";
    static COUPON_MANAGEMENT = "coupon-management";
    static PRODUCT_MANAGEMENT = "product-management";
    static PRODUCT_MANAGEMENT_TYPE = "product-management-type";
    static ORDER_MANAGEMENT = "order-management";
}

export class AppMessage {
    static PUB_SYS_CONFIG_ERROR = 'Không thể lấy dữ liệu từ máy chủ, vui lòng thử lại.';
    static UNAUTHORIZED_ERROR = 'Bạn chưa đăng nhập.';
}

export class RoleManager {
    static SA = {id: 0, code: 'SA', name: 'Super Admin'};
    static QTV = {id: 1, code: 'QTV', name: 'Quản trị viên'};
    static GNV = {id: 5, code: 'GNV', name: 'Giao - Nhận Việc'};
    static GV = {id: 6, code: 'GV', name: 'Giao Việc'};
    static NV = {id: 7, code: 'NV', name: 'Nhận Việc'};
    static Rev = {id: 8, code: 'Rev', name: 'Reviewer'};
}

export class GoogleMapConfig {
    static ADDRESS_MAP_API_KEY = 'AIzaSyB6ThjW6szWjA-XihbnRTDVw2fzHOD4_80';
    static DIV_RATE = 10000000
}

export class GoogleRecaptchaV3 {
    static RECAPTCHA_PUBLIC_KEY = '6LcP1MAZAAAAADAhYSMhC3vTcn4Lecxr0yclxr4Z';// localhost
    static DOMAIN = 'localhost'
}

export class StatusManager {
    static USER_ACTIVATED = 1;
    static USER_DEACTIVATED = 0;
    static USER_DELETED = -1;
    static USER_WAITING_FOR_ACTIVATION = 2;
    static USER_LOCKED = 3;
    static JOB_PENDING_REVIEW = 2;// 1 should be 1 --> testing
    static JOB_APPROVED = 2;
    static JOB_REJECTED = 3;
    static JOB_DELETED = -1;
    static JOB_ASSIGNED = 4;
    static JOB_COMPLETED = 5;
    static JOB_DRAFT = 0;
    static JOB_CANCELLED = 6;
    static STORE_ACTIVE = 2;
    static STORE_INACTIVE = 0;
    static STORE_SUSPENDED = -1;
    static STORE_PENDING_FOR_APPROVAL = 1;
    static CATEGORY_ACTIVE = 1;
    static CATEGORY_INACTIVE = 0;
    static CATEGORY_DELETED = 0;
    static COUPON_ACTIVE = 1;
    static COUPON_INACTIVE = 0;
    static PRODUCT_ACTIVE = 1;
    static PRODUCT_INACTIVE = 0;
    static PRODUCT_OUT_OF_STOCK = 2;
    static PRODUCT_DELETED = -1;
}

export class ToastrMessage {
    static TOAST_ERROR = 'toast-error';
    static TOAST_SUCCESS = 'toast-success';
    static TOAST_INFO = 'toast-info';
    static TOAST_WARNING = 'toast-warning';

}

export class ShopManagement {
    static TYPE = {
        STANDARD: 0,
        VIP: 1
    }

}

export class CouponManagement {
    static Scope = {
      ALL_ORDERS: 1, // Giam gia tat ca cac order
      CATEGORY: 2, // Giam gia tat ca san pham trong category
      PRODUCT: 3, // Giam gia tren san pham cu the
    };
    static ScopeText = [
      { id: this.Scope.ALL_ORDERS, name: "Tất cả các đơn hàng" },
      { id: this.Scope.CATEGORY, name: "Tất cả sản phẩm trong danh mục" },
      { id: this.Scope.PRODUCT, name: "Chỉ một sản phẩm" },
    ];
    // static Type = {
    //     LOWER_PERCENT: 3,  //# Giam x % cho don hang tu yk nhung ko qua zk
    //     LOWER_FIXED_VALUE: 4, //# Giam gia kx cho don hang tu yk nhung ko qua zk
    //     FIXED_PERCENT: 2, //# Giam gia x% cho tat ca don hang, san pham
    //     FIXED_VALUE: 1,  //# giam gia xk cho tat ca don hang, san pham
    // };
    static Type = {
      FIXED_VALUE: 1, //# giam gia xk cho don tu yk
      LOWER_PERCENT: 2, //# Giam x % cho don hang tu yk nhung ko qua zk
      LOWER_PERCENT_REFUND: 3, //# Hoan x% diem cho don hang tu yk nhung ko qua zk
    };
    static TypeText = {
      FIXED_VALUE: "Theo số tiền",
      LOWER_PERCENT: "Theo phần trăm",
      // FIXED_PERCENT: "Giảm x% giá trị đơn hàng cho tất cả các đơn hàng",
      // LOWER_FIXED_VALUE: "Giảm x vnđ cho đơn hàng từ y vnđ nhưng không quá z vnđ",
    };
    static TypeCoupon = {
      COUPON_TYPE_1: 1,
      COUPON_TYPE_2: 2,
    };
    static TypeTextCoupon = {
      COUPON_TYPE_1: "Giảm giá sản phẩm",
      COUPON_TYPE_2: "Hoàn điểm",
    };
    static QuantityType = {
      LIMITED: 1,
      UNLIMITED: 0,
    };
    static QuantityTypeText = [
      { id: this.QuantityType.LIMITED, name: "Giới hạn số lần sử dụng" },
      { id: this.QuantityType.UNLIMITED, name: "Không giới hạn số lần sử dụng" },
    ];
    static StatusType = {
      COUPON_ACTIVE: 1,
      COUPON_INACTIVE: 0,
      COUPON_INCOMING: 2,
    };
    static StatusText = {
      COUPON_ACTIVE: "Đang diễn ra",
      COUPON_INACTIVE: "Đã kết thúc",
      COUPON_INCOMING: "Sắp diễn ra",
    };
  }

export class ProductManagement {
    static Type = {
        GENERAL: 0,
        SPECIAL: 2,
        TYPE1: 1
    };
    static TypeText = {
        GENERAL: 'General',
        SPECIAL: 'Special',
        TYPE1: 'Type 1'
    };
    static Status = {
        ACTIVE: 1,
        INACTIVE: 0,
        OUT_OF_STOCK: 2,
        DELETED: -1
    };
    static StatusText = {
        ACTIVE: 'Đang hoạt động',
        INACTIVE: 'Đã ngừng kích hoạt',
        OUT_OF_STOCK: 'Hết hàng',
        DELETED: 'Đã xoá'
    };
    static PriceType = {
        FIXED_PRICE: 1,
        DEALABLE_PRICE: 2
    };
    static PriceTypeText = {
        FIXED_PRICE: 'Giá cố định',
        DEALABLE_PRICE: 'Giá thoả thuận'
    };
    static DiscountType = {
        NO_DISCOUNT: 3,
        PERCENT: 2,
        FIXED_VALUE: 1
    };
    static DiscountTypeText = {
        NO_DISCOUNT: 'Không có giảm giá',
        PERCENT: 'Theo %',
        FIXED_VALUE: 'Số cố định'
    };
    static DiscountValue = {
        FIXED_MIN: 0,
        PERCENT_MAX: 100,
        PERCENT_MIN: 0
    };
    static PriceUnit = {
        VND: 1,
        USD: 2
    };
    static PriceUnitText = {
        VND: 'VNĐ',
        USD: 'USD'
    };
    static BasePriceValue = {
        MIN: 0,
        MAX: 1000000000000
    };
    static QuantityValue = {
        MIN: 1,
        MAX: 10000
    };

    static UnitProductText = {
        CHIEC: "Chiếc",
        CAI: "Cái",
        BO: "Bộ",
        CUON: "Cuộn",
        QUYEN: "Quyển",
        MET: "Mét",
        MET_VUONG: "Mét vuông",
        MET_KHOI: "Mét khối"
    };
    
    static UnitProductValue = {
        CHIEC: 1,
        CAI: 2,
        BO: 3,
        CUON: 4,
        QUYEN: 5,
        MET: 6,
        MET_VUONG: 7,
        MET_KHOI: 8
    };
}

export class AttributeManagement {
    static Type = {
        Product: 1,
        Coupon: 2
    }
}

export class ServiceManagement {
    static ShorteningUrlService = {
        Mode: {
            New: 0,
            Update: 1
        }
    };
    static SKUService = {
        Mode: {
            New: 0,
            Update: 1
        }
    }
}

export class AdsManagement {
    static DEFAULT_START_TIME = 0;
    static DEFAULT_END_TIME = 23;
    static ADS_TYPE_VIDEO = 0;
    static ADS_TYPE_IMAGE = 1;
    static ADS_TYPE_AUDIO = 2;
    static ADS_PENDING_FOR_REVIEW = 1
    static ADS_APPROVED = 2
    static ADS_DECLINED = 3
    static ADS_SUSPENDED = 4
    static ADS_DELETED = -1
    static ADS_PRIORITY_LOW = 1
    static ADS_PRIORITY_MEDIUM = 2
    static ADS_PRIORITY_HIGH = 3
}

export class FileMessage {
    static DEFAULT_FILE = 'File không đúng định dạng';
    static DEFAULT_VIDEO_SIZE = 'File đã vượt quá 10MB';
}

export class ShopOrderStatus {
    static PENDING_FOR_PAID = {
      text: "Chờ xác nhận thông tin",
      value: 1,
    };
    static PENDING_FOR_APPROVAL = {
      text: "Chờ xác nhận xử lý đơn",
      value: 2,
    };
    static PROCESSING = {
      text: "Đang xử lý",
      value: 3,
    };
    static DELIVERING = {
      text: "Đang vận chuyển",
      value: 4,
    };
    static DELIVERED = {
      text: "Đã giao",
      value: 5,
    };
    static CANCELLED = {
      text: "Đã hủy",
      value: 6,
    };
    static DECLINED = {
      text: "Đã từ chối",
      value: 7,
    };
  }

export class ActionOrderStatus {
    static CONFIRMPAYMENT = 1 
    static ACCEPT = 2 
    static DELIVER = 3 
    static CONFIRMDELIVERY = 4 
    static DECLINE = 5 
}

export class ImageConstants {
    static DEFAULT_COVER = "default_cover.png";
    static DEFAULT_AVATAR = "default_avatar.png";
    static DEFAULT_CATEGORY_PHOTO = "default_category_photo.png";
    static DEFAULT_PRODUCT_PHOTO = "default_product_photo.png";
    static DEFAULT_COUPON_COVER = "default_coupon_cover.png";
}

export class PAYMENT_METHOD {
    static CASH = {
        value: 1,
        text: "Thanh toán khi nhận hàng"
    };
    static TRANSFER = {
        value: 2,
        text: "Chuyển khoản"
    };
}

export class PAYMENT_ACCOUNT_TYPE {
    static NONE = 0;
    static PERSONAL = 1;
    static COMPANY = 2;
 
}

export class OrderPayStatus {
    static ACCEPTED = {
        text: "Đã thanh toán",
        value: 1
    };
    static CANCELLED = {
        text: "Chưa thanh toán",
        value: 2
    };
}

export class MasterTimeConfig {
    static ALL = {
         value : "ALL",
     label : "Tất cả",
    };
    static LAST_MONTH = {
        value : "LAST_MONTH",
         label : "Tháng trước",
    };
    static THIS_WEEK = {
        value :"THIS_WEEK",
       label : "Theo tuần",
   };
    static THIS_MONTH = {
         value :"THIS_MONTH",
        label : "Theo tháng",
    };
    static THIS_YEAR_QUARTERS = {
        value :"THIS_YEAR_QUARTERS",
       label : "Theo quý",
   };
    static THIS_YEAR = {
     value : "THIS_YEAR",
         label : "Them năm",
    };
    static TIME_RANGE = {
        value : "TIME_RANGE",
        label : "Thời gian khác",
    };
    static CLEAR_TIME = {
        value : "",
        label : "Tất cả",
    };
    static ListTimes = [
        // {label: this.THIS_WEEK.label, value: this.THIS_WEEK.value},
        // {label: this.THIS_MONTH.label, value: this.THIS_MONTH.value},
        // {label: this.THIS_YEAR_QUARTERS.label, value: this.THIS_YEAR_QUARTERS.value},
        // {label: this.THIS_YEAR.label, value: this.THIS_YEAR.value},
        {label: this.TIME_RANGE.label, value: this.TIME_RANGE.value},
    ];
};

export class TabReportConfig {
    static REVENUE = {
        value: "revenue",
        label: "Doanh thu",
    };
    static PRODUCT_TOP_SALE = {
        value: "product-top-sale",
        label: "Sản phẩm bán chạy",
    };
    static GEOGRAPHY = {
        value: "report-order-total-quantity-geography",
        label: "SL & GT theo địa lý",
    };
    static PRODUCT_CANCEL_DECLINE = {
        value: "report-product-cancel-decline",
        label: "Lý do hủy/ từ chối",
    };
};

export class MessageErrors {
    static Data = [
        {
            key: "MSG1",
            message: "Tên đăng nhập hoặc mật khẩu không đúng."
        },
        {
            key: "MSG2",
            message: "Tài khoản của bạn đã bị khóa do bạn đã nhập tên đăng nhập hoặc mật khẩu sai quá {failed_times} lần, vui lòng liên hệ quản trị viên để được trợ giúp."
        },
        {
            key: "MSG3",
            message: "Tài khoản của bạn không tồn tại hoặc chưa được kích hoạt. Vui lòng liên hệ quản trị viên để được trợ giúp."
        },
        {
            key: "MSG4",
            message: "Bạn phải nhập trường này."
        },
        {
            key: "MSG10",
            message: "Đã có lỗi xảy ra, vui lòng thử lại hoặc liên hệ với quản trị viên để biết thêm thông tin chi tiết."
        },
        {
            key: "Service_Terms_And_Conditions",
            message: "Bạn phải đồng ý với các điều khoản này."
        },
        {
            key: "Number_Is_In_Use",
            message: "Số điện thoại đã được sử dụng."
        },
        {
            key: "FullName_Too_Long",
            message: "Họ tên quá dài (Tối đa 100 kí tự)."
        },
        {
            key: "FullName_Contain_Special_Character",
            message: "Họ tên không được chứa kí tự đặc biệt."
        },
        {
            key: "PhoneNumber_Too_Long",
            message: "Số điện thoại quá dài (Tối đa 12 kí tự)."
        },
        {
            key: "PhoneNumber_Contain_Special_Character_Or_Wrong_Format",
            message: "Số điện thoại không được chứa kí tự đặc biệt hoặc định dạng không đúng."
        },
        {
            key: "Unauthorized",
            message: "Bạn không có quyền để thực hiện chức năng này, vui lòng kiểm tra lại hoặc đăng nhập bằng tài khoản khác."
        },
        {
            key: "Activation_Token_Error",
            message: "Mã kích hoạt của bạn không đúng hoặc đã quá hạn. Vui lòng thử lại hoặc liên hệ với quản trị viên để được trợ giúp."
        },
        {
            key: "Activation_Token_Activate_Again",
            message: "Mã kích hoạt của bạn đã được sử dụng, vui lòng kiểm tra lại."
        },
        {
            key: "Activation_Token_Expired",
            message: "Mã kích hoạt của bạn đã hết hạn, vui lòng thử lại hoặc liên hệ với quản trị viên."
        },
        {
            key: "OTP_Resend_Time_In",
            message: "Bạn không được phép nhận 2 mã OTP trong vòng {0} phút."
        },
        {
            key: "Forgot_Password_Email_Username_Not_Found",
            message: "Tài khoản không tồn tại, vui lòng thử lại."
        },
        {
            key: "Forgot_Password_Not_Match",
            message: "Mật khẩu mới và mật khẩu xác nhận không giống nhau."
        },
        {
            key: "Forgot_Password_Old_PWD_Incorrect",
            message: "Mật khẩu cũ của bạn không đúng, vui lòng thử lại."
        },
        {
            key: "Item_Do_Not_Exist",
            message: "Không tìm thấy bản ghi."
        },
        {
            key: "Item_Already_Exists",
            message: "Bản ghi đã tồn tại."
        },
        {
            key: "Data_Integrity_Error",
            message: "Lỗi toàn vẹn dữ liệu."
        },
        {
            key: "IP_Format",
            message: "Định dạng IP không đúng."
        },
        {
            key: "Email_Format",
            message: "Định dạng email không đúng."
        },
        {
            key: "RequestEntityTooLarge",
            message: "Dữ liệu tải lên vượt quá giới hạn cho phép."
        },
        {
            key: "File_Type_Not_Support",
            message: "Định dạng file không được hỗ trợ."
        },
        {
            key: "File_Not_Found",
            message: "File không tồn tại."
        },
        {
            key: "No_Sample_File",
            message: "Chưa có file mẫu."
        },
        {
            key: "PWD_Len",
            message: "Mật khẩu quá ngắn, tối thiếu 6 kí tự."
        },
        {
            key: "PWD_Len_Max",
            message: "Mật khẩu quá dài, tối đa 100 kí tự."
        },
        {
            key: "PWD_No_Upper_Letter",
            message: "Mật khẩu của bạn phải chứa ít nhất 1 kí tự chữ hoa."
        },
        {
            key: "PWD_No_Special_Character",
            message: "Mật khẩu của bạn phải chứa ít nhất 1 kí tự đặc biệt."
        },
        {
            key: "PWD_No_Number",
            message: "Mật khẩu của bạn phải chứa ít nhất 1 kí tự số."
        },
        {
            key: "PWD_Not_Match",
            message: "Mật khẩu mới và mật khẩu xác nhận không giống nhau."
        },
        {
            key: "PWD_Only_Allow_Number",
            message: "Mật khẩu của bạn phải là số, không được chứa kí tự khác."
        },
        {
            key: "PWD_Must_Has_Character",
            message: "Mật khẩu của bạn phải chứa ít nhất một kí tự là chữ."
        },
        {
            key: "Invalid_Captcha",
            message: "Captcha không hợp lệ."
        },
        {
            key: "Upload_Gap_Time_Not_Reach",
            message: "Thời gian tối thiểu giữa 2 lần tải file là {num} giây."
        },
        {
            key: "Location_Invalid",
            message: "Vui lòng nhập đúng định dạng vị trí."
        },
        {
            key: "No_Record_Found",
            message: "Không tìm thấy bản ghi"
        },
        {
            key: "Input_Max_Len_Err",
            message: "Độ dài tối đa cho phép là {0} kí tự."
        },
        {
            key: "Input_Min_Len_Err",
            message: "Độ dài tối thiểu cho phép là {0} kí tự."
        },
        {
            key: "Input_Safe_String_Err",
            message: "Chỉ cho phép các kí tự KHÔNG đặc biệt."
        },
        {
            key: "Job_Unavailable",
            message: "Công việc hoặc người lao động không khả dụng."
        },
        {
            key: "Job_Application_Not_Cancelable",
            message: "Không thể hủy ứng tuyển do công việc này đã bị hủy hoặc bạn đã hủy trước đó."
        },
        {
            key: "Job_Application_Cannot_Be_Declined",
            message: "Không thể từ chối."
        },
        {
            key: "Job_Application_List_Not_Found",
            message: "Không tìm thấy bản ghi."
        },
        {
            key: "Job_Application_Not_Authorized",
            message: "Bạn không thể xem dữ liệu này."
        },
        {
            key: "Job_Application_Can_Not_Be_Mark_As_Finished",
            message: "Không thể yêu cầu xác nhận hoàn thành công việc."
        },
        {
            key: "Resource_File_Name_Len_Too_Long",
            message: "Tên tập tin quá dài!"
        },
        {
            key: "Resource_File_Size_Too_Large",
            message: "Dung lượng tập tin quá lớn!"
        },
        {
            key: "Resource_File_Name_Not_Allowed",
            message: "Tên tập tin không được chứa kí tự đặc biệt."
        },
        {
            key: "Start_Date_Later_Than_End_Date",
            message: "Ngày bắt đầu không được muộn hơn ngày kết thúc."
        },
        {
            key: "Request_Error",
            message: "Param is missing."
        },
        {
            key: "Feedback_Not_Authorized_To_Send_Feedback",
            message: "Bạn không thể gửi đánh giá cho người thuê hoặc công nhân này do bạn không phải là người tạo việc hoặc người làm việc cho công việc này."
        },
        {
            key: "Exception_Error",
            message: "Critical, Exception occurred!"
        },
        {
            key: "Exception_Captcha_In_Valid",
            message: "Phiên làm việc đã hết hạn, vui lòng tải lại trang và thử lại."
        },
        {
            key: "UserManagement_Account_Not_Found",
            message: "Không tìm thấy tài khoản."
        },
        {
            key: "AdsManagement_Can_Not_Find_Available_Ads_Due_To_No_Occupation_Found",
            message: "Không tìm thấy bất kì quảng cáo nào do người dùng hoặc công việc không xác định được nghành nghề."
        },
        {
            key: "AdsManagement_Can_Not_Find_Available_Ads_Due_To_No_Job_Id_Found",
            message: "Không tìm thấy bất kì quảng cáo nào do người dùng hoặc công việc không xác định được công việc."
        },
        {
            key: "Shop_Category_Can_Not_Add_Sub_Category_In_To_Inactive_Category",
            message: "Không thể thêm Category con vào Category cha do Category cha đã bị khoá."
        },
        {
            key: "Json_Format_Incorrect",
            message: "Định dạng JSON không đúng."
        },
        {
            key: "Shop_Category_Not_Found",
            message: "Không tìm thấy category."
        },
        {
            key: "Shop_Coupon_Not_Found",
            message: "Không tìm thấy coupon."
        },
        {
            key: "Shop_Coupon_Not_Owner",
            message: "Bạn không có quyền xem thông tin này."
        },
        {
            key: "Shop_Coupon_Code_Is_Existed",
            message: "Mã đã tồn tại."
        },
        {
            key: "Shop_Coupon_Applicable_Object_Not_Found",
            message: "Không tìm thấy đối tượng áp dụng mã giảm giá."
        },
        {
            key: "Shop_Coupon_Value_Must_Greater_Than_Zero",
            message: "Giá trị giảm giá phải lớn hơn hơn 0."
        },
        {
            key: "Shop_Coupon_Min_Value_Must_Greater_Than_Zero",
            message: "Giá trị đơn hàng tối thiểu(min-value) phải lớn hơn 0."
        },
        {
            key: "Shop_Coupon_Max_Value_Must_Greater_Than_Zero",
            message: "Giá trị giảm giá tối đa (max-value) phải lớn hơn 0."
        },
        {
            key: "Shop_Coupon_Is_Not_Applicable",
            message: "Không thể sử dụng mã giảm giá cho đơn hàng này."
        },
        {
            key: "Shop_Store_Not_Found",
            message: "Không tìm thấy store."
        },
        {
            key: "Shop_Coupon_Owner_Not_Found",
            message: "Không tìm thấy người tạo."
        },
        {
            key: "Shop_Category_Parent_Not_Found",
            message: "Không tìm thấy category cha."
        },
        {
            key: "Shop_Category_Inactive",
            message: "Category đang bị khóa."
        },
        {
            key: "Shop_Category_Not_Owner",
            message: "Bạn không có quyền xem thông tin này."
        },
        {
            key: "Shop_Category_Can_Not_Delete_Due_To_Has_Child",
            message: "Category này không thể bị xóa do có các Category con."
        },
        {
            key: "Shop_Category_Created_For_Not_Found",
            message: "Không tìm thấy người dùng để tạo category."
        },
        {
            key: "Shop_Product_Not_Found",
            message: "Không tìm thấy sản phẩm."
        },
        {
            key: "Shop_Product_Not_Owner",
            message: "Bạn không phải chủ sở hữu của sản phẩm này."
        },
        {
            key: "Shop_Product_Category_Not_Found",
            message: "Không tìm thấy category."
        },
        {
            key: "Shop_Product_Category_Not_Owner",
            message: "Bạn không thể thêm sản phầm vào category mình không sở hữu."
        },
        {
            key: "Shop_Product_Store_Not_Found",
            message: "Cửa hàng không tồn tại."
        },
        {
            key: "Shop_Product_Store_Not_Owner",
            message: "Bạn không thể thêm sản phẩm vào của hàng mình không sở hữu."
        },
        {
            key: "Shop_Product_Base_Price_Range",
            message: "Giá cơ sở không hợp lệ."
        },
        {
            key: "Shop_Product_Discount_Value_Range",
            message: "Giá trị giảm giá không hợp lệ."
        },
        {
            key: "Shop_Product_Quantity_Value_Range",
            message: "Số lượng phải lớn hơn 1 và nhỏ hơn 10000."
        },
        {
            key: "Shop_Product_Remaining_Quantity_Is_Not_Enough",
            message: "Số lượng sản phẩm còn lại không đủ."
        },
        {
            key: "Shop_Product_New_Date_Value_Range",
            message: "Ngày bắt đầu để hiện thị trạng thái hàng mới về phải sớm hơn ngày kết thúc."
        },
        {
            key: "Shop_Product_Flashing_Date_Value_Range",
            message: "Ngày bắt đầu để hiện thị trạng thái Flash Sales về phải sớm hơn ngày kết thúc."
        },
        {
            key: "Shop_Product_Profile_Name_Duplicated",
            message: "Tên bộ thuộc tính của sản phẩm bị trùng."
        },
        {
            key: "Shop_Product_Attribute_Not_Allowed",
            message: "Thuộc tính {attr} không nằm trong danh sách thuộc tính có thể thêm vào sản phẩm này."
        },
        {
            key: "Shop_Product_Profile_Not_Owner",
            message: "Bạn không phải chủ sở hữu của bộ thuộc tính này."
        },
        {
            key: "Shop_Product_Profile_Required",
            message: "Bạn phải cung cấp ít nhất 1 bộ thuộc tính để tiến hành tạo sản phẩm."
        },
        {
            key: "Shop_Product_Created_For_Not_Found",
            message: "Không tìm thấy người dùng để tạo category."
        },
        {
            key: "Shop_Product_Attr_Duplicated",
            message: "Thuộc tính của sản phẩm bị trùng lặp."
        },
        {
            key: "Shop_Product_Attr_Not_Found",
            message: "Không tìm thấy thuộc tính."
        },
        {
            key: "Shop_Product_Attr_Not_Owner",
            message: "Bạn không có quyền xem thông tin này."
        },
        {
            key: "Shop_Store_Not_Found",
            message: "Không tìm thấy cửa hàng."
        },
        {
            key: "Shop_Store_Not_Owner",
            message: "Bạn không phải chủ cửa hàng."
        },
        {
            key: "Shop_Store_Is_Suspended",
            message: "Cửa hàng bị khoá."
        },
        {
            key: "Shop_Store_Already_Activated",
            message: "Cửa hàng đã được kích hoạt từ trước."
        },
        {
            key: "Shop_Store_Is_Pending_For_Approval",
            message: "Cửa hàng chưa được phê duyệt."
        },
        {
            key: "Shop_Store_Created_For_Not_Found",
            message: "Không tìm thấy người dùng để tạo cửa hàng."
        },
        {
            key: "Shop_Store_Already_Activated",
            message: "Cửa hàng đã được kích hoạt từ trước."
        },
        {
            key: "SKU_Validation_Not_OK",
            message: "SKU không hợp lệ."
        },
        {
            key: "SKU_Validation_Len",
            message: "SKU phải có từ 10 đến 36 kí tự."
        },
        {
            key: "ShortenUrl_Validation_Len",
            message: "Url rút gọn chỉ được có tối đa 255 kí tự."
        },
        {
            key: "ShortenUrl_Validation_Not_OK",
            message: "Url rút gọn không hợp lệ."
        },
        {
            key: "Shop_UserCoupon_Not_Found",
            message: "Mã khuyến mại không tồn tại."
        },
        {
            key: "Shop_UserCoupon_Already_Saved",
            message: "Mã khuyến mãi đã được lưu trước đó, bạn chỉ được lưu một lần."
        },
        {
            key: "Shop_UserCoupon_Already_Used_For_Account",
            message: "Mã giảm giá đã được sử dụng cho tài khoản này, Bạn không thể sử dụng lại một lần nữa."
        },
        {
            key: "Shop_UserCategory_Existed",
            message: "Nhóm sản phẩm đã được thêm trước đó, bạn không thể thêm lại. khuyến mại không tồn tại."
        },
        {
            key: "Shop_UserCategory_ROOT",
            message: "Bạn không thể sử dụng nhóm sản phẩm của hệ thống."
        },
        {
            key: "Shop_FeedBack_Not_Found",
            message: "Không tìm thấy đánh giá."
        },
        {
            key: "Shop_FeedBack_Not_Owner",
            message: "Bạn không phải chủ của đánh giá này."
        },
        {
            key: "Shop_Order_Product_List_Not_Valid",
            message: "Danh sách sản phẩm không hợp lệ."
        },
        {
            key: "Shop_Order_Product_Belong_Owner",
            message: "Bạn không thể đặt hàng sản phẩm của chính mình."
        },
        {
            key: "Shop_Order_Coupon_List_Not_Valid",
            message: "Danh sách mã giảm giá không hợp lệ."
        },
        {
            key: "Shop_Order_Coupon_Not_Valid",
            message: "Mã giảm giá không hợp lệ."
        },
        {
            key: "Shop_Order_Failure",
            message: "Rất tiếc, chúng tôi không thể đặt đơn hàng của bạn lúc này. Vui lòng thử lại."
        },
        {
            key: "Shop_Order_Not_Found",
            message: "Đơn hàng không tồn tại."
        },
        {
            key: "Shop_Order_Not_Owner",
            message: "Bạn không phải chủ sở hữu của đơn hàng này."
        },

        {
            key: "Shop_Order_Cannot_Be_Accepted",
            message: "Không thể tiếp nhận đơn hàng."
        },
        {
            key: "Shop_Order_Cannot_Be_Deliver",
            message: "Không thể vận chuyển đơn hàng."
        },
        {
            key: "Shop_Order_Cannot_Be_Confirm_Delivered",
            message: "Không thể xác nhận đã giao đơn hàng."
        },
        {
            key: "Shop_Order_Cannot_Be_Confirm_Payment",
            message: "Không thể xác nhận thanh toán đơn hàng."
        },

        {
            key: "Shop_Order_Cannot_Be_Declined",
            message: "Không thể từ chối đơn hàng."
        },
        {
            key: "Shop_Order_Cannot_Be_Cancelled",
            message: "Không thể hủy đơn hàng."
        },
        {
            key: "Shop_Order_Cannot_Be_Paid",
            message: "Không thể thanh toán đơn hàng."
        },
        {
            key: "Shop_Order_Cannot_Be_Finished",
            message: "Không thể xác nhận hoàn thành đơn hàng."
        },
        {
            key: "Shop_Notification_Not_Found",
            message: "Không tìm thấy thông báo."
        },
        {
            key: "Shop_Coupon_Can_Not_Be_Updated_Due_To_In_Use",
            message: "Bạn không thể cập nhật mã giảm giá này do mã này đang được sử dụng."
        },
        {
            key: "Shop_Coupon_Can_Not_Be_Deleted_Due_To_In_Use",
            message: "Bạn không thể xoá mã giảm giá này do mã này đã được sử dụng."
        },
        {
            key: "Shop_Attribute_Not_Found",
            message: "Không tìm thấy thuộc tính."
        },
        {
            key: "Shop_Attribute_Not_Authorized",
            message: "Bạn không có quyền tạo bản ghi này."
        },
        {
            key: "Shop_Attribute_Duplicated",
            message: "Thuộc tính bị trùng lặp."
        },
        {
            key: "Shop_Product_Featured_Less_Than_Twenty",
            message: "Bạn chỉ được phép chọn 20 sản phẩm nổi bật."
        },
        {
            key: "Shop_Relative_Product_InValid",
            message: "Sản phẩm liên quan không hợp lệ."
        },
        {
            key: "Shop_Product_Type2_Input_Attribute_InValid",
            message: "Các thuộc tính đầu vào của sản phẩm loại 2 không hợp lệ. Bạn phải chọn tất cả giá trị thuộc tính."
        },
        {
            key: "Shop_Product_Type3_Input_Attribute_InValid",
            message: "Các thuộc tính đầu vào của sản phẩm loại 3 không hợp lệ. Bạn phải chọn tất cả giá trị thuộc tính."
        },
        {
            key: "Shop_Product_Type3_Input_Param_InValid",
            message: "Các tham số đầu vào của sản phẩm loại 3 không hợp lệ. Bạn phải chọn tất cả giá trị tham số"
        },
        {
            key: "Shop_Product_Type3_Input_Param_InValid",
            message: "Các tham số đầu vào của sản phẩm loại 3 không hợp lệ. Bạn phải chọn tất cả giá trị tham số"
        },
        {
            key: "Shop_Product_Type3_Input_Param_InValid",
            message: "Các tham số đầu vào của sản phẩm loại 3 không hợp lệ. Bạn phải chọn tất cả giá trị tham số"
        },
        {
            key: "Shop_Product_Type3_Input_Param_InValid",
            message: "Các tham số đầu vào của sản phẩm loại 3 không hợp lệ. Bạn phải chọn tất cả giá trị tham số"
        },
        {
            key: "Shop_Cart_Detail_Not_Found",
            message: "Không tìm thấy sản phẩm trong giỏ hàng."
        },
        {
            key: "Shop_Cart_Not_Found",
            message: "Không tìm thấy giỏ hàng."
        },
        {
            key: "Shop_Cart_Product_Belong_Owner",
            message: "Bạn không thể thêm vào giỏ hàng sản phẩm của chính mình."
        },
        {
            key: "Input_Reward_Point_Invalid",
            message: "Điểm thưởng không hợp lệ"
        },
    ]
}